export const CONTACT = {
  name: "Costruzioni Ciosko",
  phoneDisplay: "320 897 8227",
  phoneTel: "+393208978227",
  whatsapp: "https://wa.me/393208978227",
  email: "costruzioniciosko@gmail.com",
  area: "Veneto",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/azienda", label: "Azienda" },
  { to: "/servizi", label: "Servizi" },
  { to: "/lavori", label: "Lavori" },
  { to: "/privati", label: "Privati" },
  { to: "/aziende", label: "Aziende" },
  { to: "/contatti", label: "Contatti" },
];

export const LEGAL = {
  titolare: "Costruzioni Ciosko di Cheloski Erhan",
  sede: "Via Pietro Valentini, 4 int. — 31056 Roncade (TV)",
  cf: "C.F. CHLRHN90R28Z148F",
};

export const ZONES = [
  "Venezia", "Mestre", "Marghera", "Treviso", "Padova", "Jesolo",
  "Chioggia", "Mirano", "San Donà di Piave", "Dolo", "Mira", "Spinea",
];

export const SERVICES = [
  {
    slug: "opere-murarie",
    icon: "BrickWall",
    title: "Opere Murarie",
    desc: "Realizzazione di opere murarie, tramezzi, muri, divisori e interventi di costruzione.",
    long: "Realizziamo opere murarie di ogni tipo: muri, tramezzi, divisori, opere in laterizio e interventi di costruzione ex novo o di modifica. Ogni lavorazione viene eseguita a regola d'arte, con materiali selezionati e un controllo costante della qualità in cantiere.",
    points: ["Muri e tramezzi", "Divisori e opere in laterizio", "Interventi di muratura strutturale", "Opere di completamento"],
    img: "/images/servizio-opere-murarie.jpg",
  },
  {
    slug: "ristrutturazioni",
    icon: "Hammer",
    title: "Ristrutturazioni",
    desc: "Interventi di ristrutturazione e riqualificazione di abitazioni, locali e immobili.",
    long: "Gestiamo ristrutturazioni complete o parziali di abitazioni, locali commerciali e immobili: dalle demolizioni alla consegna finale, con un cantiere organizzato e un referente chiaro per tutto lo svolgimento dei lavori.",
    points: ["Ristrutturazioni complete", "Riqualificazione di appartamenti e ville", "Rifacimento di bagni e locali", "Ridistribuzione degli spazi"],
    img: "/images/servizio-ristrutturazioni.jpg",
  },
  {
    slug: "cartongesso",
    icon: "Layers",
    title: "Cartongesso",
    desc: "Realizzazione di pareti, controsoffitti, velette e soluzioni in cartongesso.",
    long: "Progettiamo e realizziamo soluzioni in cartongesso su misura: pareti divisorie, controsoffitti, velette luminose e sistemi con isolamento termoacustico, con finiture pulite e pronte per la tinteggiatura.",
    points: ["Pareti divisorie", "Controsoffitti e velette", "Isolamento termoacustico", "Soluzioni su misura"],
    img: "/images/servizio-cartongesso.jpg",
  },
  {
    slug: "intonaci-finiture",
    icon: "PaintRoller",
    title: "Intonaci e Finiture",
    desc: "Lavorazioni di intonacatura, rasatura e finitura delle superfici.",
    long: "Eseguiamo intonaci civili, rasature e finiture di superfici interne ed esterne, con particolare attenzione alla planarità e alla qualità del risultato finale.",
    points: ["Intonaci civili", "Rasature e finiture lisce", "Ripristino delle superfici", "Preparazione alla tinteggiatura"],
    img: "/images/servizio-intonaci.jpg",
  },
  {
    slug: "manutenzione-edile",
    icon: "Wrench",
    title: "Manutenzione Edile",
    desc: "Interventi di manutenzione ordinaria e straordinaria su immobili e strutture.",
    long: "Ci occupiamo di manutenzione ordinaria e straordinaria su immobili residenziali e strutture: ripristino di facciate, balconi, elementi deteriorati e interventi programmati per preservare il valore dell'edificio.",
    points: ["Manutenzione ordinaria e straordinaria", "Ripristino di facciate e balconi", "Interventi su immobili e strutture", "Manutenzioni programmate"],
    img: "/images/servizio-manutenzione.jpg",
  },
  {
    slug: "aziende-cantieri",
    icon: "Building2",
    title: "Interventi per Aziende e Cantieri",
    desc: "Servizi e lavorazioni edili per imprese, aziende, cantieri e operatori del settore.",
    long: "Affianchiamo imprese, studi tecnici e operatori del settore con lavorazioni edili professionali: opere murarie per conto terzi, supporto operativo in cantiere e collaborazioni continuative.",
    points: ["Lavorazioni per imprese e studi tecnici", "Supporto operativo in cantiere", "Opere murarie per conto terzi", "Collaborazioni continuative"],
    img: "/images/servizio-aziende.jpg",
  },
];

export const PILLARS = [
  { icon: "HardHat", title: "Professionalità", desc: "Affrontiamo ogni lavoro con metodo, attenzione e responsabilità." },
  { icon: "ClipboardList", title: "Organizzazione", desc: "Una gestione ordinata del cantiere permette di lavorare in modo efficiente." },
  { icon: "Gem", title: "Qualità", desc: "Poniamo particolare attenzione alla qualità delle lavorazioni e delle finiture." },
  { icon: "Handshake", title: "Affidabilità", desc: "Rispettiamo gli impegni presi e manteniamo un rapporto trasparente con il cliente." },
  { icon: "ShieldCheck", title: "Sicurezza", desc: "La sicurezza delle persone e l'organizzazione del cantiere sono elementi fondamentali del nostro lavoro." },
];

export const STEPS = [
  { num: "01", title: "Sopralluogo", desc: "Analizziamo le esigenze e valutiamo il lavoro." },
  { num: "02", title: "Preventivo", desc: "Definiamo interventi, lavorazioni e costi in modo chiaro." },
  { num: "03", title: "Organizzazione", desc: "Pianifichiamo il lavoro e organizziamo il cantiere." },
  { num: "04", title: "Realizzazione", desc: "Eseguiamo le lavorazioni con attenzione e professionalità." },
];

export const PROJECT_CATEGORIES = ["Ristrutturazioni", "Opere murarie", "Cartongesso", "Finiture", "Manutenzioni", "Cantieri"];

export const PROJECTS = [
  {
    id: "ristrutturazione-appartamento",
    title: "Ristrutturazione appartamento",
    cat: "Ristrutturazioni",
    loc: "Mestre (VE)",
    img: "/images/lavoro-ristrutturazione.jpg",
    desc: "Ristrutturazione completa di un appartamento: demolizioni, nuove tramezzature, intonaci e finiture.",
    details: ["Intervento chiavi in mano", "Nuova distribuzione degli spazi", "Finiture complete"],
  },
  {
    id: "murature-tramezzi",
    title: "Nuove murature e tramezzi",
    cat: "Opere murarie",
    loc: "Treviso",
    img: "/images/lavoro-muratura.jpg",
    desc: "Realizzazione di murature interne e parete a vista con finitura curata dei giunti.",
    details: ["Muratura in laterizio", "Parete a vista", "Controllo della planarità"],
  },
  {
    id: "controsoffitto-velette",
    title: "Controsoffitto con velette LED",
    cat: "Cartongesso",
    loc: "Padova",
    img: "/images/lavoro-cartongesso.jpg",
    desc: "Controsoffitto in cartongesso con velette luminose e abbassamenti tecnici.",
    details: ["Velette per illuminazione LED", "Lastre antiumidità", "Rasatura e finitura"],
  },
  {
    id: "rasature-finiture",
    title: "Rasature e finiture civili",
    cat: "Finiture",
    loc: "Jesolo (VE)",
    img: "/images/lavoro-finiture.jpg",
    desc: "Rasatura completa delle pareti e finiture pronte per la tinteggiatura.",
    details: ["Rasante a base gesso", "Finitura liscia", "Controllo della planarità"],
  },
  {
    id: "restauro-facciata",
    title: "Restauro facciata",
    cat: "Manutenzioni",
    loc: "Chioggia (VE)",
    img: "/images/lavoro-manutenzione.jpg",
    desc: "Intervento di manutenzione e ripristino della facciata di un edificio esistente.",
    details: ["Risanamento dell'intonaco", "Ponteggio dedicato", "Ripristino elementi deteriorati"],
  },
  {
    id: "cantiere-residenziale",
    title: "Cantiere residenziale",
    cat: "Cantieri",
    loc: "Mirano (VE)",
    img: "/images/lavoro-cantiere.jpg",
    desc: "Costruzione di una nuova unità residenziale: opere strutturali e murarie.",
    details: ["Struttura in cemento armato", "Murature perimetrali", "Cantiere organizzato"],
  },
];

export const slugify = (s) =>
  s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
